<template>
    <div class="card" :class="[shadow ? 'card-shadow' : '', hover ? 'hover': '']" v-bind="$attrs">
        <div v-if="headerTitle || customHeaderTitle" class="card-header text-gray-600" :class="[headerClass]">
            {{ headerTitle }}
            <slot v-if="customHeaderTitle" name="card-header" />
        </div>
        <div class="card-body" :class="[cardBodyClass]">
            <slot name="card-body" />
        </div>
    </div>
</template>

<script>
export default {
    name: "BaseCard",

    props: {
        headerTitle: {
            type: String,
            default: "",
        },
        
        headerClass: {
            type: String,
            default: "",
        },

        cardBodyClass: {
            type: String,
            default: "",
        },

        shadow: {
            type: Boolean,
            default: false,
        },

        hover: {
            type: Boolean,
            default: false,
        },

        customHeaderTitle: {
            type: Boolean,
            default: false,
        },
    },
};
</script>